import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'afm-usage',
  templateUrl: './usage.component.html',
  styleUrls: ['./usage.component.scss']
})
export class UsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
